/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ScriptRunnerRoleEnum = 'vcds:ro-script-run' | 'vcds:rw-script-run';

export const ScriptRunnerRoleEnum = {

    VCDS_RO_SCRIPT_RUN: 'vcds:ro-script-run' as ScriptRunnerRoleEnum,

    VCDS_RW_SCRIPT_RUN: 'vcds:rw-script-run' as ScriptRunnerRoleEnum
};

